import React from 'react';
import ProfileCard from './Profile/ProfileCard';
import SkillSection from './Skills/SkillSection';
import BioSection from './Profile/BioSection';
import HobbySection from './Profile/HobbySection';
import QualificationSection from './Qaulification/QualificationSection';
import SideBottomBar from './SideBottomBar/SideBottomBar';
import ExperienceSection from './Experience/ExperienceSection';
import ServicesSection from './Services/ServicesSection';
import ProjectsSection from './Projects/ProjectsSection';
import ContactSection from './Contact/ContactSection';

const Section = ({ id, eyebrow, title, subtitle, children }) => (
   <section id={id} className="mt-12 scroll-mt-24 animate-fadeUp">
      <div className="mb-5">
         <span className="section-eyebrow">{eyebrow}</span>
         <h2 className="section-title mt-2">{title}</h2>
         {subtitle && <p className="section-subtitle">{subtitle}</p>}
      </div>
      {children}
   </section>
);

const HomePage = () => {
   return (
      <>
         <SideBottomBar />
         <main className="mx-auto max-w-screen-md px-4 sm:px-5 pb-28 md:pb-12 md:pl-24">
            <ProfileCard />

            <div className="mt-6">
               <BioSection />
               <HobbySection />
            </div>

            <Section
               id="experience"
               eyebrow="Career"
               title="Experience"
               subtitle="Where I have worked and what I did there."
            >
               <ExperienceSection />
            </Section>

            <Section
               id="services"
               eyebrow="What I do"
               title="Services"
               subtitle="The things I can help with."
            >
               <ServicesSection />
            </Section>

            <Section
               id="projects"
               eyebrow="Selected work"
               title="Projects"
               subtitle="Website and Android apps I have built."
            >
               <ProjectsSection />
            </Section>

            <Section
               id="skills"
               eyebrow="Toolbox"
               title="Skills"
               subtitle="Languages and tools I use."
            >
               <SkillSection />
            </Section>

            <Section
               id="qualification"
               eyebrow="Background"
               title="Qualification"
               subtitle="Educational background and academic journey."
            >
               <QualificationSection />
            </Section>

            <Section id="contact" eyebrow="Contact" title="Let&apos;s collaborate">
               <ContactSection />
            </Section>

            <footer className="mt-12 border-t border-zinc-200/70 dark:border-zinc-800/70 pt-6 pb-2 text-center">
               <p className="text-[12px] text-zinc-500 dark:text-zinc-400">
                  © {new Date().getFullYear()} Tanbir Hossen 
               </p>
            </footer>
         </main>
      </>
   );
};

export default HomePage;
